export enum MessageType {
  info = 'info',
  error = 'error',
  action = 'action',
  response = 'response',
}
